import React from "react";
import { Radio } from "@mui/material";
import {
  PaymentMethodItemContainer,
  PaymentMethodContent,
  PaymentMethodTitle,
  PaymentMethodDescription,
} from "./styles";

interface PaymentMethod {
  id: number;
  title: string;
  description: string;
  icon: React.ReactNode;
  disabled: boolean;
}

interface PaymentMethodItemProps {
  paymentMethod: PaymentMethod;
  selectedPaymentMethod: number | null;
  onSelect: (id: number) => void;
}

const PaymentMethodItem: React.FC<PaymentMethodItemProps> = ({
  paymentMethod,
  selectedPaymentMethod,
  onSelect,
}) => {
  return (
    <PaymentMethodItemContainer $disabled={paymentMethod.disabled}>
      {paymentMethod.icon}
      <PaymentMethodContent>
        <PaymentMethodTitle $disabled={paymentMethod.disabled}>
          {paymentMethod.title}
        </PaymentMethodTitle>
        <PaymentMethodDescription $disabled={paymentMethod.disabled}>
          {paymentMethod.description}
        </PaymentMethodDescription>
      </PaymentMethodContent>
      <Radio
        value={paymentMethod.id.toString()}
        name="radio-buttons"
        checked={selectedPaymentMethod === paymentMethod.id}
        onChange={() => onSelect(paymentMethod.id)}
        disabled={paymentMethod.disabled}
      />
    </PaymentMethodItemContainer>
  );
};

export default PaymentMethodItem;
